import Swiper, { Autoplay } from 'swiper';
import { isScriptLoaded, markScriptLoaded } from '@/scripts/core/loaded';

const SECTION_NAME = 'how-to';

function howTo() {
    const howToSliders = document.querySelectorAll('[data-how-to-slider]');

    if (!howToSliders.length) {
        return;
    }

    howToSliders.forEach((howToSlider) => {
        const parentSection = howToSlider.closest('[data-how-to]');
        const howToStepToggles = howToSlider.querySelectorAll('[data-how-to-step-toggle]');

        const swiper = new Swiper(howToSlider, {
            loop: false,
            allowTouchMove: false,
            preventClicks: false,
            preventClicksPropagation: false,
            autoplay: {
                delay: 6000
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            modules: [Autoplay]
        });

        swiper.autoplay.stop();

        window.addEventListener('scroll', () => {
            if (
                parentSection.classList.contains('how-to--autoplaying') ||
                window.scrollY + window.innerHeight < parentSection.offsetTop
            ) {
                return;
            }

            parentSection.classList.add('how-to--autoplaying');

            swiper.autoplay.start();
        });

        howToStepToggles.forEach((howToStepToggle) => {
            howToStepToggle.addEventListener('click', () => {
                const stepNumber = howToStepToggle.getAttribute('data-step');

                swiper.slideTo(
stepNumber, 1, false
);
                swiper.autoplay.start();
            });
        });
    });
}

const run = () => {
    howTo();
};

// Ensure section JS only runs once
if (!isScriptLoaded(SECTION_NAME)) {
    document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', run);

    markScriptLoaded(SECTION_NAME);
}
